import { Box } from '@mui/material';
import { CustomChart } from 'modules';
import * as ds from './dataService';



export type TreasuryYieldCurveAreaChartProps = {};

export const FC = () => {
  const { data } = ds.useQuery();
  return (
    <Box
      flex='1 1 0'
    >
      <CustomChart.FC
        yDomain={[
          0,
          6
        ]}
        type='AREA'
        data={data}
        title='US Treasury Yield Curve'
      />
    </Box>
  );
};
